import React from 'react'
import { Link } from 'gatsby'
import Menu from './menu'

const Topbar = ({ current, showMenu }) => (
  <nav className="topbar">
    <div className="topbar-content">
      <Link className="logo" to="/" alt="Home" />
      <a className="menu-link" href="javascript:void(0);" onClick={showMenu}>
        Menu
      </a>
      <Menu current={current} />
    </div>
  </nav>
)
export default Topbar
